import { resolveMediaUrl } from '@/lib/media';

type MediaImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

/** Plain <img> for CMS media — resolves legacy /upload/* to Supabase Storage URL */
export function MediaImg({ src, ...props }: MediaImgProps) {
  if (!src) return null;
  const resolved = typeof src === 'string' ? resolveMediaUrl(src) : src;
  return <img src={resolved} {...props} />;
}
